import React, { useState, useEffect } from "react";
import {
    FaTimes,
    FaSave,
    FaTools,
    FaUserPlus,
    FaTrash,
} from "react-icons/fa";
import { FaClock } from "react-icons/fa6";

export const TicketTakenAction = ({ isOpen, onClose, ticket, onSave }) => {
    const [loading, setLoading] = useState(false);

    // Dummy Teknisi
    const technicianOptions = [
        { id: 1, name: "Andri" },
        { id: 2, name: "Budi" },
        { id: 3, name: "Rizky" },
        { id: 4, name: "Fajar" },
    ];

    // Form Data
    const [formData, setFormData] = useState({
        technicians: [""],
        scheduleDate: "",
        scheduleTime: "",
        scheduleReason: "",
        workNote: "",
        workProgress: 0,
    });

    // Reset form saat modal dibuka/tutup
    useEffect(() => {
        if (isOpen && ticket) {
            setFormData({
                technicians: [""],
                scheduleDate: "",
                scheduleTime: "",
                scheduleReason: "",
                workNote: "",
                workProgress: ticket.workDetails?.progress || 0,
            });
        }
    }, [isOpen, ticket]);

    // Handle perubahan teknisi
    const handleTechnicianChange = (index, value) => {

        // Cek apakah teknisi sudah dipilih sebelumnya
        const isDuplicate = formData.technicians.some(
            (tech, i) => tech === value && i !== index
        );

        if (isDuplicate) {
            alert("Teknisi tersebut sudah dipilih.");
            return;
        }

        const updated = [...formData.technicians];
        updated[index] = value;

        setFormData({
            ...formData,
            technicians: updated,
        });
    };

    // Tambah teknisi
    const addTechnician = () => {
        setFormData({
            ...formData,
            technicians: [...formData.technicians, ""],
        });
    };

    // Hapus teknisi
    const removeTechnician = (index) => {
        const updated = formData.technicians.filter((_, i) => i !== index);

        setFormData({
            ...formData,
            technicians: updated.length ? updated : [""],
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        // Validasi teknisi
        const selectedTechnicians = formData.technicians.filter(Boolean);

        if (selectedTechnicians.length === 0) {
            alert("Harap pilih minimal 1 teknisi.");
            setLoading(false);
            return;
        }

        if (!formData.scheduleDate || !formData.scheduleReason) {
            alert("Harap isi tanggal dan alasan penjadwalan ulang.");
            setLoading(false);
            return;
        }

        const payload = {
            ...formData,
            technicians: selectedTechnicians,
        };

        console.log("Submitting Ticket Action:", payload);

        if (onSave) await onSave(payload);

        setTimeout(() => {
            setLoading(false);
            onClose();
        }, 1000);
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-slate-900/80 backdrop-blur-sm"
                onClick={onClose}
            />

            {/* Modal */}
            <div className="relative w-full max-w-[1000px] bg-slate-900 border border-slate-700 rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]">

                {/* Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-700 bg-slate-800/50">
                    <div>
                        <h2 className="text-lg font-bold text-white flex items-center gap-2">
                            <FaTools className="text-cyan-400" />
                            Aksi Tiket: Ambil Tiket
                        </h2>

                        <p className="text-xs text-slate-400 mt-1">
                            Pengambilan Tiket Gangguan
                        </p>
                    </div>

                    <button
                        onClick={onClose}
                        className="text-slate-400 hover:text-white transition-colors p-2 rounded-full hover:bg-slate-700"
                    >
                        <FaTimes size={18} />
                    </button>
                </div>

                {/* Body */}
                <div className="p-6 overflow-y-auto custom-scrollbar flex-1">

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                        {/* Teknisi */}
                        <div>
                            <div className="flex items-center justify-between mb-3">
                                <label className="block text-xs font-semibold text-slate-400 uppercase tracking-wider">
                                    Pilih Teknisi
                                </label>

                                <button
                                    type="button"
                                    onClick={addTechnician}
                                    className="flex items-center gap-2 text-xs px-3 py-2 rounded-lg bg-cyan-600 hover:bg-cyan-500 text-white transition"
                                >
                                    <FaUserPlus />
                                    Tambah Teknisi
                                </button>
                            </div>

                            <div className="space-y-3">
                                {formData.technicians.map((tech, index) => (
                                    <div
                                        key={index}
                                        className="flex items-center gap-2"
                                    >
                                        <select
                                            value={tech}
                                            onChange={(e) =>
                                                handleTechnicianChange(index, e.target.value)
                                            }
                                            className="w-full bg-slate-900 border border-slate-600 text-slate-200 text-sm rounded-lg px-4 py-3 focus:outline-none focus:border-cyan-500 transition-colors"
                                        >
                                            <option value="">
                                                Pilih Teknisi...
                                            </option>

                                            {technicianOptions.map((item) => {
                                                const alreadySelected = formData.technicians.includes(
                                                    String(item.id)
                                                );

                                                return (
                                                    <option
                                                        key={item.id}
                                                        value={item.id}
                                                        disabled={
                                                            alreadySelected &&
                                                            String(tech) !== String(item.id)
                                                        }
                                                    >
                                                        {item.name}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                        {formData.technicians.length > 1 && (
                                            <button
                                                type="button"
                                                onClick={() =>
                                                    removeTechnician(index)
                                                }
                                                className="p-3 rounded-lg bg-red-500/10 hover:bg-red-500/20 text-red-400 transition"
                                            >
                                                <FaTrash />
                                            </button>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Schedule */}
                        <div className="space-y-4">
                            <h3 className="font-semibold border-b border-slate-700 pb-2 text-white">
                                Set Tanggal dan Jam Penjadwalan
                            </h3>

                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-xs font-semibold text-slate-400 mb-2">
                                        Tanggal Baru
                                    </label>

                                    <input
                                        type="date"
                                        value={formData.scheduleDate}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                scheduleDate: e.target.value,
                                            })
                                        }
                                        className="w-full bg-slate-900 border border-slate-600 text-slate-200 text-sm rounded-lg px-4 py-3 focus:outline-none focus:border-cyan-500"
                                    />
                                </div>

                                <div>
                                    <label className="block text-xs font-semibold text-slate-400 mb-2">
                                        Jam
                                    </label>

                                    <input
                                        type="time"
                                        value={formData.scheduleTime}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                scheduleTime: e.target.value,
                                            })
                                        }
                                        className="w-full bg-slate-900 border border-slate-600 text-slate-200 text-sm rounded-lg px-4 py-3 focus:outline-none focus:border-cyan-500"
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="block text-xs font-semibold text-slate-400 mb-2">
                                    Alasan Penjadwalan Ulang
                                    <span className="text-red-400"> *</span>
                                </label>

                                <textarea
                                    rows="3"
                                    placeholder="Contoh: Pelanggan tidak ada di rumah..."
                                    value={formData.scheduleReason}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            scheduleReason: e.target.value,
                                        })
                                    }
                                    className="w-full bg-slate-900 border border-slate-600 text-slate-200 text-sm rounded-lg px-4 py-3 focus:outline-none focus:border-cyan-500 resize-none"
                                />
                            </div>

                            <div className="p-3 bg-blue-500/5 border border-blue-500/10 rounded-lg flex items-start gap-3">
                                <FaClock className="text-blue-400 mt-1" />

                                <p className="text-xs text-blue-200/80">
                                    Jadwal akan ditambahkan ke riwayat dan
                                    notifikasi akan dikirim ke pelanggan.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="p-4 border-t border-slate-700 bg-slate-800/50 flex justify-end gap-3">
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={loading}
                        className="px-5 py-2.5 rounded-lg text-sm font-medium text-slate-300 hover:bg-slate-700 hover:text-white transition-colors disabled:opacity-50"
                    >
                        Batal
                    </button>

                    <button
                        onClick={handleSubmit}
                        disabled={loading}
                        className="flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-medium text-white bg-cyan-600 hover:bg-cyan-500 shadow-lg shadow-cyan-900/20 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {loading ? (
                            <>
                                <span className="animate-spin h-4 w-4 border-2 border-white/30 border-t-white rounded-full" />
                                Menyimpan...
                            </>
                        ) : (
                            <>
                                <FaSave />
                                Simpan Perubahan
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};